import React, {useContext, useEffect, useState} from 'react'

import EventsGrid, { gridImagesMapper } from './Grid'
import { API_HOST, API_URL } from '../../App'

import { RestaurantContext } from '../../providers/restaurant'

import { useScrollOnRender } from '../../utils/hooks/scroll'

import CustomSwiper from '../../components/layout/CustomSwiper/CustomSwiper'

import { ReservationFormModal, checkReservationData } from '../Reservation/Reservation'

import heroStar from "../../assets/img/events/hero-star.png"
import heroHeart from "../../assets/img/events/hero-heart.png"
import heroSmile from "../../assets/img/events/hero-smile.png"
import heroStar2 from "../../assets/img/events/hero-star-2.png"
import heroStar3 from "../../assets/img/events/hero-star-3.png"

import localStyle from "./style.module.scss"
import VisitorRulesModal from '../Reservation/Modals/RulesModal'


export default function Events() {
    useScrollOnRender(true)

    const {
        places, current,
    } = useContext(RestaurantContext)

    const [lastMonthEvents, setLME] = useState()
    const [reservationModalState, setReservationModalState] = useState({
        showing: false,
        svr: false,
    })

    const showVisitorRules = (val) => {
        setReservationModalState({...reservationModalState, svr: val})
    };

    useEffect(() => {
        if (places?.[current]) {
            const params = new URLSearchParams([
                ['last_month', 'True'],
            ])
            fetch(API_URL + `/events?${params.toString()}`).then(
                response => response.json()
            ).then(
                content => {
                    setLME(gridImagesMapper(content))
                }
            ).catch(
                e => setLME(null)
            )
        }
    }, [places, current])

    return (
        <>
        <section className={localStyle["hero-events"]}>
            <p className={localStyle["tg-authentic"] + ' ' + localStyle["tg-upper"]}>
                <span>Соб<br/>ытия</span>
                <img src={heroStar} alt={"Звезда одна"}/>
                <img src={heroHeart} alt={"Сердце"}/>
                <img src={heroSmile} alt={"Смайл"}/>
                <img src={heroStar2} alt={"Звезда другая"}/>
                <img src={heroStar3} alt={"Звезда третья"}/>
            </p>
            <button className={localStyle["primary"] + ' ' + localStyle["tg-upper"]}
                onClick={e => {
                    setReservationModalState({showing: true})
                }}
            >Забронировать стол</button>
        </section>
        <section className={
            localStyle["events"] + ' ' +
            localStyle["block"] + ' ' +
            localStyle["container"]
        }>
            <CustomSwiper showDetails={true} />
            <button className="primary tg-upper"
                onClick={e => {
                    setReservationModalState({showing: true})
                }}
            >Забронировать стол</button>
        </section>
        <section className={localStyle["galery"]}>
            <p className={localStyle["tg-authentic"] + ' ' + localStyle["tg-upper"]}>Как это было в прошлом месяце</p>
            <EventsGrid items={lastMonthEvents}/>
            {/* <p className={localStyle["social"]}>
                Подписаться
                <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="30" rx="15" fill="#41B64D"/>
                    <path d="M15 8.85542C16.988 8.85542 17.259 8.85542 18.0723 8.85542C18.7952 8.85542 19.1566 9.03614 19.4277 9.12651C19.7892 9.30723 20.0602 9.39759 20.3313 9.66868C20.6024 9.93976 20.7831 10.2108 20.8735 10.5723C20.9639 10.8434 21.0542 11.2048 21.1446 11.9277C21.1446 12.741 21.1446 12.9217 21.1446 15C21.1446 17.0783 21.1446 17.259 21.1446 18.0723C21.1446 18.7952 20.9639 19.1566 20.8735 19.4277C20.6928 19.7892 20.6024 20.0602 20.3313 20.3313C20.0602 20.6024 19.7892 20.7831 19.4277 20.8735C19.1566 20.9639 18.7952 21.0542 18.0723 21.1446C17.259 21.1446 17.0783 21.1446 15 21.1446C12.9217 21.1446 12.741 21.1446 11.9277 21.1446C11.2048 21.1446 10.8434 20.9639 10.5723 20.8735C10.2108 20.6928 9.93976 20.6024 9.66868 20.3313C9.39759 20.0602 9.21687 19.7892 9.12651 19.4277C9.03614 19.1566 8.94578 18.7952 8.85542 18.0723C8.85542 17.259 8.85542 17.0783 8.85542 15C8.85542 12.9217 8.85542 12.741 8.85542 11.9277C8.85542 11.2048 9.03614 10.8434 9.12651 10.5723C9.30723 10.2108 9.39759 9.93976 9.66868 9.66868C9.93976 9.39759 10.2108 9.21687 10.5723 9.12651C10.8434 9.03614 11.2048 8.94578 11.9277 8.85542C12.741 8.85542 13.012 8.85542 15 8.85542ZM15 7.5C12.9217 7.5 12.741 7.5 11.9277 7.5C11.1145 7.5 10.5723 7.68072 10.1205 7.86145C9.66868 8.04217 9.21687 8.31325 8.76506 8.76506C8.31325 9.21687 8.13253 9.57831 7.86145 10.1205C7.68072 10.5723 7.59036 11.1145 7.5 11.9277C7.5 12.741 7.5 13.012 7.5 15C7.5 17.0783 7.5 17.259 7.5 18.0723C7.5 18.8855 7.68072 19.4277 7.86145 19.8795C8.04217 20.3313 8.31325 20.7831 8.76506 21.2349C9.21687 21.6867 9.57831 21.8675 10.1205 22.1386C10.5723 22.3193 11.1145 22.4096 11.9277 22.5C12.741 22.5 13.012 22.5 15 22.5C16.988 22.5 17.259 22.5 18.0723 22.5C18.8855 22.5 19.4277 22.3193 19.8795 22.1386C20.3313 21.9578 20.7831 21.6867 21.2349 21.2349C21.6867 20.7831 21.8675 20.4217 22.1386 19.8795C22.3193 19.4277 22.4096 18.8855 22.5 18.0723C22.5 17.259 22.5 16.988 22.5 15C22.5 13.012 22.5 12.741 22.5 11.9277C22.5 11.1145 22.3193 10.5723 22.1386 10.1205C21.9578 9.66868 21.6867 9.21687 21.2349 8.76506C20.7831 8.31325 20.4217 8.13253 19.8795 7.86145C19.4277 7.68072 18.8855 7.59036 18.0723 7.5C17.259 7.5 17.0783 7.5 15 7.5Z" fill="white"/>
                    <path d="M15 11.1145C12.8313 11.1145 11.1145 12.8313 11.1145 15C11.1145 17.1687 12.8313 18.8855 15 18.8855C17.1687 18.8855 18.8855 17.1687 18.8855 15C18.8855 12.8313 17.1687 11.1145 15 11.1145ZM15 17.5301C13.6446 17.5301 12.4699 16.4458 12.4699 15C12.4699 13.6446 13.5542 12.4699 15 12.4699C16.3554 12.4699 17.5301 13.5542 17.5301 15C17.5301 16.3554 16.3554 17.5301 15 17.5301Z" fill="white"/>
                    <path d="M18.9759 11.9277C19.475 11.9277 19.8795 11.5231 19.8795 11.0241C19.8795 10.525 19.475 10.1205 18.9759 10.1205C18.4769 10.1205 18.0723 10.525 18.0723 11.0241C18.0723 11.5231 18.4769 11.9277 18.9759 11.9277Z" fill="white"/>
                </svg>
            </p> */}
        </section>
        <ReservationFormModal
            open={reservationModalState.showing}
            onCancel={e => {
                setReservationModalState({showing: false})
            }}
            onFinish={values => {
                const {
                    fd, missing, error,
                } = checkReservationData({values})
                if (missing.size > 0) {
                    setReservationModalState(prev => ({...prev, result: false, error}))
                }
                setReservationModalState(prev => ({...prev, pending: true}))
                fetch(API_HOST + '/reservation', {
                    method: "POST",
                    body: fd,
                }).then(
                    async response => {
                        if (response.status < 500) return await response.json()
                        else return Promise.reject(await response.text())
                    }
                ).then(
                    content => {
                        setReservationModalState(prev => ({...prev, result: true}))
                    }
                ).catch(
                    e => {
                        setReservationModalState(prev => ({...prev, result: false}))
                    }
                ).finally(
                    () => {setReservationModalState(prev => ({...prev, pending: false}))}
                )
            }}
            className={localStyle['reservation-form-modal']}
            {...reservationModalState}
            showVisitorRules={showVisitorRules}
        />
        <VisitorRulesModal open={reservationModalState.svr} setOpen={showVisitorRules} />
        </>
    )
}
